import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Collapse, TextField, Grid, Box } from '@material-ui/core';
import Switch from 'react-switch';

const FILTER_STATE_INIT = {
  nombre: '',
  showInactivos: false,
};

const ItemClasificacionesGridFiltros = (props) => {
  const intl = useIntl();
  const [init, setInit] = useState(false);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [filtersState, setFiltersState] = useState(FILTER_STATE_INIT);

  useEffect(() => {
    if (props.filterResetInputs) {
      setFiltersState(FILTER_STATE_INIT);
    }
  }, [props.filterResetInputs]);

  useEffect(() => {
    !props.dropdownActive && props.setFilterResetInputs(false);
    !props.dropdownActive && setFiltersLoading(false);
  }, [props.dropdownActive]);

  const handleChange = (name, value) => {
    props.handleFilterChange();
    let query = {};
    query = { ...filtersState };
    query[name] = value;

    if (query.nombre !== '') {
      props.setSearchActive(true);
    } else {
      props.setSearchActive(false);
    }

    setInit(true);
    props.setFilterQuery(query);
  };

  useEffect(() => {
    handleChange('showInactivos', filtersState.showInactivos);
  }, [filtersState.showInactivos]);

  const handleOnEnter = (e, name, value) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      handleChange(name, value);
    }
  };

  const handleChangeInactivosSwitch = (value) => {
    setFiltersState({ ...filtersState, showInactivos: value });
    handleChange('showInactivos', value);
  };

  return (
    <>
      {init && (
        <Collapse in={props.dropdownActive}>
          <Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
            <Grid component={Box} item xs={3}>
              <form noValidate autoComplete="off">
                <TextField
                  label={intl.formatMessage({ id: 'Clasificación', defaultMessage: 'Clasificación' })}
                  placeholder={intl.formatMessage({ id: 'Clasificación', defaultMessage: 'Clasificación' })}
                  name="nombre"
                  value={filtersState.nombre}
                  onChange={(e) => setFiltersState({ ...filtersState, nombre: e.target.value })}
                  onKeyDown={(e) => handleOnEnter(e, 'nombre', filtersState.nombre)}
                  onBlur={(e) => handleChange('nombre', filtersState.nombre)}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid component={Box} item xs={2} className="align-self-end">
              <form noValidate autoComplete="off">
                <div className="d-flex inline justify-content-around align-items-center">
                  {intl.formatMessage({ id: 'itemClasificacionesAbm.render.filtros.ver_inactivos', defaultMessage: 'Ver Inactivas' })}
                  <Switch
                    onChange={(value) => handleChangeInactivosSwitch(value)}
                    checked={filtersState.showInactivos}
                    disabled={filtersLoading}
                    offColor="#FF4961"
                    onColor="#28D094"
                  />
                </div>
              </form>
            </Grid>
          </Grid>
        </Collapse>
      )}
    </>
  );
};

export default ItemClasificacionesGridFiltros;


